
<template>
  <div>
  <b-container fluid>
    <b-row>

      <b-col col cols="4" sm="2" md="2" lg="2">
      <input value="/docs/acts_and_rules/supply_code.pdf" id="sc1" hidden>
       <b-card
        style="border:none;"
        class="mb-2 "
        @mouseover="hover_in('sc')" @mouseout="hover_out('sc')" @click="showDoc('sc1')"
        >
        <b-icon icon="card-checklist" font-scale="3" variant="dark" class="card-icon" id="sc" ></b-icon>
        <br><b-button variant="transparent" class="link" >যোগান ক’ড্‌</b-button>
      </b-card>

    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
        <input value="/docs/acts_and_rules/distribution_code.pdf" id="dc1" hidden>
        <b-card
        style="border:none"
        class="mb-2"
        @mouseover="hover_in('dc')" @mouseout="hover_out('dc')" @click="showDoc('dc1')"
        >
        <b-icon icon="layout-text-sidebar-reverse" font-scale="3" variant="dark" class="card-icon" id="dc" ></b-icon>
        <br><b-button variant="transparent" class="link textAlign15px" >বিতৰণ ক’ড্‌</b-button>
      </b-card>


  </b-col>
  <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_KnowYourTariff">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('kyt')" @mouseout="hover_out('kyt')" 
        >
        <b-icon icon="graph-up" font-scale="3" variant="dark" class="card-icon" id="kyt" ></b-icon>
        <br><b-button variant="transparent" class="link" >আপোনাৰ শুল্কৰ বিষয়ে জানক</b-button>
      </b-card>
    </router-link>
  </b-col>
  <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_TariffOrder">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2 "
        @mouseover="hover_in('to')" @mouseout="hover_out('to')"
        >
        <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="to" ></b-icon>
        <br><b-button variant="transparent" class="link" >শুল্ক সম্পৰ্কীয় আদেশ</b-button>
      </b-card>
</router-link>
    </b-col>

    

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_TariffFiling">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('tfp')" @mouseout="hover_out('tfp')"
        >
        <b-icon icon="files" font-scale="3" variant="dark" class="card-icon" id="tfp"></b-icon>
        <br><b-button variant="transparent" class="link" >শুল্ক দাখিল তথা আৱেদন</b-button>
      </b-card>
    </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
    <input value="/docs/acts_and_rules/electricity_act_2003.pdf" id="ea1" hidden>

      <b-card
      title=""
      style="max-width: 15rem;border:none"
      class="mb-2"
      @mouseover="hover_in('ea')" @mouseout="hover_out('ea')" @click="showDoc('ea1')"
      >
      <b-icon icon="file-earmark-text" font-scale="3" variant="dark" class="card-icon" id="ea" ></b-icon>
      <br><b-button variant="transparent" class="link" >বিদ্যুৎ আইন, ২০০৩</b-button>
    </b-card>

    </b-col>
  </b-row>

  <b-row>


    <b-col col cols="4" sm="2" md="2" lg="2">
      <input value="/docs/acts_and_rules/RTI_act_2005.pdf" id="roi1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2 "
        @mouseover="hover_in('roi')" @mouseout="hover_out('roi')" @click="showDoc('roi1')"
        >
        <b-icon icon="file-check" font-scale="3" variant="dark" class="card-icon" id="roi" ></b-icon>
        <br><b-button variant="transparent" class="link textAlign15px" >তথ্য জনাৰ অধিকাৰ আইন, ২০০৫ </b-button>
      </b-card>
    </a>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <input value="/docs/acts_and_rules/consumer_grievances_redressal_guidelines.pdf" id="cg1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('cg')" @mouseout="hover_out('cg')" @click="showDoc('cg1')"
        >
        <b-icon icon="briefcase" font-scale="3" variant="dark" class="card-icon" id="cg" ></b-icon>
        <br><b-button variant="transparent" class="link" >উপভোক্তা অভিযোগ নিষ্পত্তি নিৰ্দেশনা</b-button>
      </b-card>

    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">

      <a  href="https://powermin.gov.in/sites/default/files/webform/notices/Tariff_Policy-Resolution_Dated_28012016.pdf" target="_blank">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2 "
        @mouseover="hover_in('tp')" @mouseout="hover_out('tp')"
        >
        <b-icon icon="list-ul" font-scale="3" variant="dark" class="card-icon" id="tp" ></b-icon>
        <br><b-button variant="transparent" class="link" >শুল্ক নীতি</b-button>
      </b-card>
    </a>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <a  href="https://powermin.gov.in/en/content/national-electricity-policy" target="_blank">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2 "
        @mouseover="hover_in('nep')" @mouseout="hover_out('nep')"
        >
        <b-icon icon="file-richtext" font-scale="3" variant="dark" class="card-icon" id="nep" ></b-icon>
        <br>
        <b-button   variant="transparent" class="link textAlign15px" >ৰাষ্ট্ৰীয় বিদ্যুৎ নীতি</b-button>
      </b-card>
    </a>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
    <input value="/docs/acts_and_rules/RE_policy.pdf" id="rep1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2 "
        @mouseover="hover_in('rep')" @mouseout="hover_out('rep')" @click="showDoc('rep1')"
        >
        <b-icon icon="file-ruled" font-scale="3" variant="dark" class="card-icon" id="rep" ></b-icon>
        <br><b-button variant="transparent" class="link textAlign20px" >গ্ৰাম্য বৈদ্যুতিকৰণ নীতি</b-button>
      </b-card>

    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
        <input value="/docs/acts_and_rules/assam_solar_energy_policy_2017.pdf" id="solar1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('solar')" @mouseout="hover_out('solar')" @click="showDoc('solar1')"
        >
        <b-icon icon="brightness-high" font-scale="3" variant="dark" class="card-icon" id="solar"></b-icon>
        <br><b-button variant="transparent" class="link" id="card-button">অসম সৌৰ শক্তি নীতি, ২০১৭</b-button>
      </b-card>

    </b-col>
    <b-col col cols="4" sm="2" md="2" lg="2">
        <input value="/docs/acts_and_rules/assam_electricity_duty_amendment_act_2018.pdf" id="ed1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('ed')" @mouseout="hover_out('ed')" @click="showDoc('ed1')"
        >
        <b-icon icon="card-text" font-scale="3" variant="dark" class="card-icon" id="ed"></b-icon>
        <br><b-button variant="transparent" class="link textAlign15px" id="card-button"> অসম বিদ্যুৎ শুল্ক (সংশোধনী) আইন, ২০১৮
        </b-button>
      </b-card>

    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
        <input value="/docs/acts_and_rules/fpppa.pdf" id="reg1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('reg')" @mouseout="hover_out('reg')" @click="showDoc('reg1')"
        >
        <b-icon icon="file-earmark-zip" font-scale="3" variant="dark" class="card-icon" id="reg"></b-icon>
        <br><b-button variant="transparent" class="link textAlign10px" >FPPPA নিয়ন্ত্ৰণ</b-button>
      </b-card>

    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <input value="/docs/acts_and_rules/standards_of_performance.pdf" id="sop1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('sop')" @mouseout="hover_out('sop')" @click="showDoc('sop1')"
        >
        <b-icon icon="clipboard-data" font-scale="3" variant="dark" class="card-icon" id="sop"></b-icon>
        <br><b-button variant="transparent" class="link" >প্ৰদৰ্শনৰ মানদণ্ড নিয়মাৱলী, ২০০৪</b-button>
      </b-card>

    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <input value="/docs/acts_and_rules/record_retention_manual.pdf" id="rrm1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2 card-icon"
        @mouseover="hover_in('rrm')" @mouseout="hover_out('rrm')" @click="showDoc('rrm1')"
        >
        <b-icon icon="card-heading" font-scale="3" variant="dark" class="card-icon" id="rrm"></b-icon>
        <br><b-button variant="transparent" class="link textAlign10px" >ৰেকৰ্ড ৰিটেনচন মেনুৱেল</b-button>
      </b-card>

    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <input value="/docs/acts_and_rules/assam_electricity_works_of_licensees_rules.pdf" id="rules1" hidden>

        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('rules')" @mouseout="hover_out('rules')" @click="showDoc('rules1')"
        >
        <b-icon icon="book" font-scale="3" variant="dark" class="card-icon" id="rules"></b-icon>
        <br><b-button variant="transparent" class="link textAlign10px" >
          অসম ইলেকট্ৰিচিটি ৱৰ্কচ অফ লাইচেঞ্চেছ ৰুলচ, ২০১৯</b-button>
      </b-card>

    </b-col>
      <b-col col cols="4" sm="2" md="2" lg="2">
        <input value="/docs/acts_and_rules/general_condition_of_supply_erection.pdf" id="se1" hidden>

        <b-card
        title=""
        style="max-width: 20rem;border:none"
        class="mb-2"
        @mouseover="hover_in('se')" @mouseout="hover_out('se')" @click="showDoc('se1')"
        >
        <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="se" ></b-icon>
        <br><b-button variant="transparent" class="link" >যোগান আৰু উত্থানৰ সাধাৰণ অৱস্থা</b-button>
      </b-card>

    </b-col>
    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_BeeEnergyReport">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('bee')" @mouseout="hover_out('bee')" 
        >
        <b-icon icon="bar-chart" font-scale="3" variant="dark" class="card-icon" id="bee" ></b-icon>
        <br>
        <b-button variant="transparent" class="link" >BEE শক্তি একাউণ্টিং আৰু অডিট প্ৰতিবেদন</b-button>
      </b-card>
    </router-link>
  </b-col>
  

    <b-col col cols="4" sm="2" md="2" lg="2">
        <input value="/docs/acts_and_rules/csr_apdcl.pdf" id="csr1" hidden>
        <b-card
        title=""
        style="max-width: 20rem;border:none"
        class="mb-2"
        @mouseover="hover_in('csr')" @mouseout="hover_out('csr')" @click="showDoc('csr1')"
        >
        <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="csr" ></b-icon>
        <br><b-button variant="transparent" class="link" >কৰ্পৰেট সামাজিক দায়বদ্ধতা (CSR) নীতি</b-button>
      </b-card>
    </b-col>
    <b-col col cols="4" sm="2" md="2" lg="2">
        <input value="/docs/acts_and_rules/Vigil_Mechanism_Policy.pdf" id="vgl1" hidden>
        <b-card
        title=""
        style="max-width: 20rem;border:none"
        class="mb-2"
        @mouseover="hover_in('vgl')" @mouseout="hover_out('vgl')" @click="showDoc('vgl1')"
        >
        <b-icon icon="file-check" font-scale="3" variant="dark" class="card-icon" id="vgl" ></b-icon>
        <br><b-button variant="transparent" class="link" >ভিজিল মেকানিজম নীতি</b-button>
      </b-card>
    </b-col>
    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_PoshPolicy">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2 "
        @mouseover="hover_in('to')" @mouseout="hover_out('to')"
        >
        <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="to" ></b-icon>
        <br><b-button variant="transparent" class="link" >আভ্যন্তৰীণ সমিতি এপিডিচিএলৰ তথ্য</b-button>
      </b-card>
</router-link>
    </b-col>


    </b-row>
  </b-container>

  <div>
</div>
</div>
</template>
<style scoped="true">
  .link
  {

    font-size: 0.85rem;
    font-weight: 500;
    /* font-variant: small-caps; */
    padding:0px !important;
  }

  .card-icon
    {
        transition:1.2s;
        opacity: 0.9;
    }

  .card-icon-hover{
    cursor:pointer;
    transition:1.2s;
    transform: scale(1) rotate(-360deg);
  }
.mb-2
{
  padding:0 !important;
}
@media (max-width: 768px) {
  .textAlign20px{
    margin-left: -20px;
  }
  .textAlign15px{
    margin-left: -15px;
  }
  .textAlign10px{
    margin-left: -10px;
  }
}
</style>
<script>
//var urlCommon = "http://localhost:8081/website";
//var urlCommon = "https://www.apdcl.org/website";



export default{
  methods: {
    hover_in(x){
      document.getElementById(x).classList.add("card-icon-hover");
    },
    hover_out(y){
      document.getElementById(y).classList.remove("card-icon-hover");
    },
    showDoc(id){
      var link = document.getElementById(id).value;
      console.log(link);
      window.open(this.$urlCommon + link);
    },
  },
  data()
  {
    return{

    }
  }

  }

</script>
